import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

const DATE = moment();

class DatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: DATE,
        };

        moment.locale(this.props.locale);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(date) {
        this.setState({
            date,
        });
        this.props.onDatePickerChange(date);
    }

    render() {
        return <ReactDatePicker {...this.props} selected={this.state.date} onChange={this.handleChange} />;
    }
}

DatePicker.defaultProps = {
    minDate: DATE,
    maxDate: moment(DATE).add(1, 'month'),
    dateFormat: 'LL',
};

/*
 * This component can accept more props. For the purpose of the current use of the date-picker widget
 * we only initiate those propTypes.
 * For more props for date-picker:
 * https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md
 */

/* eslint-disable react/no-unused-prop-types */
DatePicker.propTypes = {
    dateFormat: PropTypes.string,
    locale: PropTypes.oneOf(['en', 'en-ca', 'fr', 'fr-ca']).isRequired,
    maxDate: PropTypes.instanceOf(moment),
    minDate: PropTypes.instanceOf(moment),
    onDatePickerChange: PropTypes.func.isRequired,
};
/* eslint-enable react/no-unused-prop-types */

DatePicker.displayName = 'DatePicker';

export default DatePicker;
